import { useState, useEffect } from 'react';

/**
 * Hook to fetch and display the current app version
 * Version is stored in /public/version.json and incremented on each deploy
 */
export const useVersion = () => {
  const [version, setVersion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        // Add cache-busting parameter to ensure we get the latest version
        const response = await fetch(`/version.json?t=${Date.now()}`);
        if (response.ok) {
          const data = await response.json();
          setVersion(data);
        }
      } catch (error) {
        console.warn('Could not fetch version info');
      } finally {
        setLoading(false);
      }
    };

    fetchVersion();
  }, []);

  // Format version string: v1.0.0 (Build 1)
  const versionString = version 
    ? `v${version.version} (Build ${version.build})`
    : null;

  return { version, versionString, loading };
};

export default useVersion;
